<template>
  <div class="loginForm modal fade" id="siteModal">
    <row class="modal-dialog" role="document" style="width: 100%">
      <column class="col-md-3"></column>
      <column class="col-md-6">
        <va-box :title="title" theme="box-info" :isBorder="true" widgetType="">
          <div slot="content">
            <form class="form-horizontal">
              <div class="form-group">
                <label class="col-sm-3 control-label">Site Name</label>
                <div class="col-sm-9">
                  <input type="text" class="form-control" placeholder="Site Name" v-model="name" />
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label">Address</label>
                <div class="col-sm-9">
                  <input type="text" class="form-control" placeholder="Address" v-model="address" />
                </div>
              </div>
              <div class="form-group" v-if="$root.isAdmin">
                <label class="col-sm-3 control-label">Dealer</label>
                <div class="col-sm-9">
                  <select class="form-control" v-model="dealerKey" style="padding-left: 0px;">
                    <option v-for="(item,index) in $root.dealers" :data="item" :key="index" :value="item.value">
                      {{ item.title }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group" v-if="!$root.isCustomer">
                <label class="col-sm-3 control-label">Customer</label>
                <div class="col-sm-9">
                  <select class="form-control" v-model="customerKey" style="padding-left: 0px;">
                    <option v-for="(item,index) in $root.customers" :data="item" :key="index" :value="item.value">
                      {{ item.title }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group" align="center">
                <va-alert type="danger" :dismissible="true" v-show="error" style="width: 98%;">
                  <div slot="body">
                    <i class="icon fa fa-ban"></i> {{error}}
                  </div>
                </va-alert>
              </div>
            </form>
          </div>
          <div slot="footer">
            <va-button :isBlock="false" theme="danger" name="Cancel" align="right" @click.native="cancel"></va-button>
            <va-button :isBlock="false" theme="success" name="Save" align="right" @click.native="save" style="margin-right: 10px;"></va-button>
          </div>
        </va-box>
      </column>
      <column class="col-md-3"></column>
    </row>
  </div>
</template>
<script>
  import VAAlert from './VAAlert'
  import VABox from './VABox'
  import VAButton from './VAButton'
  import VASelect from './VASelect'

  import { db } from '../firebase'

  export default {
    name: 'AddSite',
    components: {
      'va-alert': VAAlert,
      'va-box': VABox,
      'va-button': VAButton,
      'va-select': VASelect
    },
    data () {
      return {
        dealerKey: '',
        customerKey: '',
        siteKey: '',
        title: 'Add Site',
        name: '',
        address: '',
        totalPrinters: 0,
        error: ''
      }
    },
    created () {
    },
    mounted () {
      this.$bus.$on('siteModal-open', (args) => {
        console.log(args)
        if (args) {
          this.title = 'Edit Site' + ' [' + args.Name + ']'
          this.siteKey = args['.key']
          this.dealerKey = args.DealerKey
          this.customerKey = args.CustomerKey
          this.name = args.Name
          this.address = args.Address
          this.totalPrinters = args.TotalPrinters
          this.error = ''
        } else {
          this.reset()
          if (this.$root.isAdmin) {
            this.dealerKey = ''
          } else if (this.$root.isDealer) {
            this.dealerKey = this.$root.user['.key']
          } else if (this.$root.isCustomer) {
            this.dealerKey = this.$root.filter.dealerKey
            this.customerKey = this.$root.filter.customerKey
          }
          this.title = 'Add Site'
        }
        $('#siteModal').modal('show')
      })
    },
    methods: {
      save () {
        let vm = this
        if (vm.isValid()) {
          const site = {
            Name: vm.name,
            Address: vm.address ? vm.address : '',
            TotalPrinters: vm.totalPrinters
          }

          if (!vm.customerKey) {
            for (var i = 0; i < vm.$root.customers.length; i++) {
              if (vm.$root.customers[i].isSelected) {
                vm.customerKey = vm.$root.customers[i].value
              }
            }
          }

          if (vm.siteKey) {
            const siteRef = db.ref('Dealers/' + vm.dealerKey + '/Customers/' + vm.customerKey + '/Sites/' + vm.siteKey)
            siteRef.set(site)
          } else {
            const siteRef = db.ref('Dealers/' + vm.dealerKey + '/Customers/' + vm.customerKey + '/Sites')
            site.TotalPrinters = 0
            siteRef.push(site)

            db.ref('Dealers/' + vm.dealerKey + '/TotalSites').once('value').then(function (snapTotalSites) {
              let totalSites = snapTotalSites.val()
              db.ref('Dealers/' + vm.dealerKey + '/TotalSites').set(totalSites + 1)
            })

            db.ref('Dealers/' + vm.dealerKey + '/Customers/' + vm.customerKey + '/TotalSites').once('value').then(function (snapTotalSites) {
              let totalSites = snapTotalSites.val()
              db.ref('Dealers/' + vm.dealerKey + '/Customers/' + vm.customerKey + '/TotalSites').set(totalSites + 1)
            })
          }
          vm.$root.reloadSlideItems()
          vm.$parent.reloadSites()
          vm.reset()
          $('#siteModal').modal('hide')
        }
      },
      cancel () {
        this.reset()
        $('#siteModal').modal('hide')
      },
      isValid () {
        this.error = ''

        if (!this.dealerKey || this.dealerKey.length === 0) {
          this.error = '* Unknown Dealer!'
          return false
        }

        if (!this.customerKey || this.customerKey.length === 0) {
          this.error = '* Please Select a Customer!'
          return false
        }

        if (!this.name || this.name.length === 0) {
          this.error = '* Please enter your Site Name!'
          return false
        }

        if (!this.address || this.address.length === 0) {
          this.error = '* Please enter your Site Addresse!'
          return false
        }

        return true
      },
      reset () {
        this.name = ''
        this.address = ''
        this.siteKey = ''
        this.dealerKey = ''
        this.customerKey = ''
        this.totalPrinters = 0
        this.error = ''
      }
    }
  }

</script>



// WEBPACK FOOTER //
// AddSite.vue?39c023a7